import { Module } from '@nestjs/common';
import { AuditModule } from '../audit/audit.module';
import { winstonConfig } from '../common/logger/winston.config';
import { PrismaModule } from '../prisma/prisma.module';
import { AsignacionesSucursalController } from './asignaciones-sucursal.controller';
import { AsignacionesSucursalService } from './asignaciones-sucursal.service';

@Module({
  imports: [PrismaModule, AuditModule],
  controllers: [AsignacionesSucursalController],
  providers: [AsignacionesSucursalService],
  exports: [AsignacionesSucursalService],
})
export class AsignacionesSucursalModule {}
